// action types
const UPDATE_PERMISSION_NOTICE_STATUS =
  'rp/permission/UPDATE_PERMISSION_NOTICE_STATUS'

// reducer
export default (state = false, { payload, type }) => {
  switch (type) {
    case UPDATE_PERMISSION_NOTICE_STATUS:
      return payload
    default:
      return state
  }
}

// action creators
// payload = boolean
export const updatePermissionNoticeStatus = payload => ({
  type: UPDATE_PERMISSION_NOTICE_STATUS,
  payload,
})
